
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fcus_1hnz8_9",
  "clickable": "awsui_clickable_1fcus_1hnz8_18",
  "precise": "awsui_precise_1fcus_1hnz8_22",
  "focus-outline": "awsui_focus-outline_1fcus_1hnz8_26",
  "application": "awsui_application_1fcus_1hnz8_35"
};
  